module.exports = __webpack_public_path__ + "img/ana.f4b4cdba.png";